/** A dash on the snow (fx 'snowdash'): a pale thrust. */
import { registerFx } from './registry';

registerFx('snowdash', (host) => ({
  skill: ({ src }) => {
    host.swingArc(src, 'thrust', '200,235,255');
    host.sfx.dash();
  },
}));
